import { inject, observer } from 'mobx-react';
import * as React from 'react';
import config from '../Config';
import LanguageStore from '../stores/LanguageStore';
import { CommonComponentsProvider } from '@teliaee/telia-common-components';

interface Props {
  languageStore?: LanguageStore;
  disableTranslationsStatistics?: boolean;
  isTestEnvironment?: boolean;
  children?: React.ReactNode;
}

@observer
class CommonComponentsProviderWrapper extends React.Component<Props> {
  public render() {
    return (
      <CommonComponentsProvider
        tier={config.componentTier}
        language={this.props.languageStore.currentLanguage}
        isTestEnvironment={this.props.isTestEnvironment}
        disableTranslationsStatistics={this.props.disableTranslationsStatistics}
      >
        {this.props.children}
      </CommonComponentsProvider>
    );
  }
}

export default inject('languageStore')(CommonComponentsProviderWrapper);
